const urlvalues = {
    baseUrl: '',
    admin: {
        admin: 'api/admin/admin',
        log: 'api/admin/log',
        organization: 'api/admin/organization',
        stats: 'api/admin/stats',
        taskEngine: 'api/admin/taskEngine',
    },
    app: {
        auth: 'api/app/auth',
        message: 'api/app/message',
        program: 'api/app/program',
        public: 'api/app/public',
        preview: 'api/app/preview',
        user: 'api/app/user',
        sensor: 'api/app/sensor',
        sleep: 'api/app/sleep',
    },
    fihr: {
        observation: 'api/fihr/observation',
    },
    portal: {
        patient: 'api/portal/patient',
        patientSensor: 'api/portal/patient/sensor',
        patientExport: 'api/portal/patient/export',
        patientFitbit: 'api/portal/patient/fitbit',
        patientGarmin: 'api/portal/patient/garmin',
        patientMessage: 'api/portal/patient/message',
        patientEvent: 'api/portal/patient/event',
        module: 'api/portal/program/module',
        program: 'api/portal/program/program',
        task: 'api/portal/program/task',
        import: 'api/portal/program/import',
        programExport: 'api/portal/program/export',
        auth: 'api/portal/auth',
        media: 'api/portal/media',
        registration: 'api/portal/registration',
        user: 'api/portal/user',
        users: 'api/portal/users',
        content: 'api/portal/content',
        analytics: 'api/portal/analytics',
        analyticsExport: 'api/portal/analytics/export',
    },
    public: {
        program: 'api/public/program',
    },
    media: {
        file: 'media/file',
        video: 'media/video',
    },
    route: {
        callback: 'route/callback',
        oauth: 'route/oauth',
    },
    socket: {
        videoChat: 'socket/videochat/hub',
    },
};

const apiUrls = { ...urlvalues };

export const setApiRoot = (baseUrl) => {
    apiUrls.baseUrl = baseUrl;
};

export const currentRoot = () => `${window.location.protocol}//${window.location.host}`;
export default apiUrls;
